module.exports = "/assets/dist/images/bodystyles_trucks.png?055336353924b9c522cd23fe9c7e8ad5";